import { useCompanyBuildings, useEnergyTypeArray } from "@/hooks";
import type { BuildingMetersType, DropdownOption } from "@/types";

type EnergyBuildingKey = keyof Pick<
  BuildingMetersType,
  "electricity" | "energy" | "gas" | "heating" | "water" // based on GetBuildings query
>;

export const useEnergyType = (
  parent: string | null = null,
  child: string | null = null,
  country: string | null = null,
) => {
  let energyTypeArray: DropdownOption[] = useEnergyTypeArray();
  const variables = {
    customerName: parent || "",
    subsidiaryName: child || "",
    country: country || "",
    zone: "",
  };
  const { buildings, loading } = useCompanyBuildings(variables);

  if (parent && child) {
    const energyTypeValues = energyTypeArray.map(
      (item: DropdownOption) => item.value,
    );

    const availableTypes = [
      ...new Set(
        (buildings ?? []).reduce<string[]>((acc, building) => {
          energyTypeValues.forEach((type: string | number) => {
            const energyKey = type as EnergyBuildingKey;
            const energyData = building[energyKey];
            if (Array.isArray(energyData) && energyData.length > 0) {
              acc.push(String(type));
            }
          });
          return acc;
        }, []),
      ),
    ];

    energyTypeArray = energyTypeArray.filter((type: DropdownOption) =>
      availableTypes.includes(type.value as string),
    );
  }

  return {
    energyType: energyTypeArray,
    loading,
  };
};
